import React from 'react';
import PropTypes from 'prop-types';
import currentSessionIdHOC from '@/connectHOCs/Sessions/currentSession/id';
import allSessionsHOC from '@/connectHOCs/Sessions/allSessions';
import sessionsSubHOC from '@/subscribeHOCs/allSessions';
import { setCurrentSession } from '@/utils/SessionUtils';
import TeamSwitcher from '../components/teamSwitcher/TeamSwitcher';

function TeamSwitcherContainer(props) {
  const { allSessions, currentSessionId, block } = props;
  const isHorizontal = block === 'top';
  return (
    <TeamSwitcher
      sessions={allSessions}
      currentSessionId={currentSessionId}
      isHorizontal={isHorizontal}
      onTeamSwitch={setCurrentSession}
    />
  );
}

TeamSwitcherContainer.defaultProps = {
  currentSessionId: null,
};

TeamSwitcherContainer.propTypes = {
  allSessions: PropTypes.array.isRequired,
  currentSessionId: PropTypes.string,
};

export default currentSessionIdHOC(
  allSessionsHOC(sessionsSubHOC(TeamSwitcherContainer))
);



// WEBPACK FOOTER //
// ./src/containers/TeamSwitcherContainer.js